// GENERATED by npm run analytics:build. Edit lib/analytics/core.ts and shopify/tracking-src/*.js.
(function () {
"use strict";
const C = (function () { const exports = {};
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTM_KEYS = exports.CLICK_KEYS = exports.TTL = exports.DAYS = exports.ADS_COOKIE = exports.ATTR_COOKIE = exports.VERSION = void 0;
exports.internalHost = internalHost;
exports.anonymousId = anonymousId;
exports.safeText = safeText;
exports.safeUrl = safeUrl;
exports.externalReferrer = externalReferrer;
exports.touch = touch;
exports.decodeAttribution = decodeAttribution;
exports.updateAttribution = updateAttribution;
exports.attributionProperties = attributionProperties;
exports.clicks = clicks;
exports.cookie = cookie;
exports.device = device;
/** Shared, side-effect-free contract, also compiled into the Shopify assets/pixel. */
exports.VERSION = 2;
exports.ATTR_COOKIE = 'cdc_attribution_v2';
exports.ADS_COOKIE = 'cdc_marketing_v2';
exports.DAYS = 30;
exports.TTL = exports.DAYS * 86400000;
exports.CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
exports.UTM_KEYS = ['source', 'medium', 'campaign', 'content', 'term', 'id'];
function internalHost(host) { return host === 'compagnonsdecoeur.fr' || host.endsWith('.compagnonsdecoeur.fr'); }
function anonymousId(source) {
    if (typeof source.randomUUID === 'function')
        return source.randomUUID();
    const bytes = source.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
function safeText(value, max = 100) {
    return typeof value === 'string' && !/@|%40|[\r\n<>]/i.test(value) ? value.trim().slice(0, max) : '';
}
function safeUrl(value) {
    try {
        const url = new URL(value);
        if (!['https:', 'http:'].includes(url.protocol))
            return '';
        // Never send query strings, hashes, checkout tokens or customer/account URLs.
        const path = /^\/(?:checkouts?|account|orders)(?:\/|$)/.test(url.pathname) ? '/checkout' : url.pathname;
        return url.origin + path.slice(0, 240);
    }
    catch {
        return '';
    }
}
function externalReferrer(value) {
    try {
        const url = new URL(value);
        return internalHost(url.hostname) ? '' : url.origin;
    }
    catch {
        return '';
    }
}
function touch(url, referrer, now) {
    const p = new URL(url).searchParams;
    const t = { at: now, landing_page: safeUrl(url), referrer: externalReferrer(referrer) };
    for (const key of exports.UTM_KEYS) {
        const value = safeText(p.get('utm_' + key));
        if (value)
            t[key] = value;
    }
    const source = (t.source || '').toLowerCase();
    const medium = (t.medium || '').toLowerCase();
    // Normalize paid aliases only; preserve organic/social and the explicit test source.
    const paid = /^(paid[_-]?social|cpc|ppc|paid|ads|social_paid)$/.test(medium);
    if ((['fb', 'facebook', 'meta', 'instagram', 'ig'].includes(source) && paid) || (!source && p.has('fbclid') && paid)) {
        t.source = 'facebook';
        t.medium = 'paid_social';
    }
    else if ((['tt', 'tiktok'].includes(source) && paid) || (!source && p.has('ttclid'))) {
        t.source = 'tiktok';
        t.medium = 'paid_social';
    }
    else if ((source === 'google' && paid) || (!source && ['gclid', 'gbraid', 'wbraid'].some(k => p.has(k)))) {
        t.source = 'google';
        t.medium = 'cpc';
    }
    if (!t.source) {
        if (t.referrer) {
            const host = new URL(t.referrer).hostname.replace(/^www\./, '');
            t.source = /(^|\.)google\./.test(host) ? 'google' : /(^|\.)(facebook|instagram)\.com$/.test(host) ? 'facebook' : host;
            t.medium = t.source === 'google' ? 'organic' : 'referral';
        }
        else {
            t.source = '(direct)';
            t.medium = '(none)';
        }
    }
    return t;
}
function decodeAttribution(raw, now) {
    try {
        const value = JSON.parse(decodeURIComponent(raw || ''));
        if (value.v !== exports.VERSION || !/^[0-9a-f-]{36}$/i.test(value.id) || value.expires <= now || value.expires > now + exports.TTL + 60000)
            return null;
        for (const t of [value.first, value.last]) {
            if (!t || !Number.isFinite(t.at) || !t.source || !t.medium || safeUrl(t.landing_page) !== t.landing_page)
                return null;
            for (const k of exports.UTM_KEYS)
                if (t[k] && safeText(t[k]) !== t[k])
                    return null;
            t.referrer = externalReferrer(t.referrer);
        }
        return { v: exports.VERSION, id: value.id, first: value.first, last: value.last, expires: value.expires, internal: value.internal === true };
    }
    catch {
        return null;
    }
}
function updateAttribution(previous, url, referrer, now, id) {
    const incoming = touch(url, referrer, now);
    const next = previous && previous.expires > now ? { ...previous } : { v: exports.VERSION, id, first: incoming, last: incoming, expires: now + exports.TTL, internal: false };
    // Direct/internal transitions never overwrite a known non-direct acquisition.
    if (incoming.source !== '(direct)') {
        const same = [...exports.UTM_KEYS, 'landing_page', 'referrer'].every(k => incoming[k] === next.last[k]);
        if (!same)
            next.last = incoming;
    }
    const debug = new URL(url).searchParams.get('cdc_tracking_test');
    if (debug === '1')
        next.internal = true;
    if (debug === '0')
        next.internal = false;
    return next;
}
function attributionProperties(a) {
    const result = { tracking_version: exports.VERSION, landing_page: a.first.landing_page, referrer: a.last.referrer,
        is_internal: a.internal, attribution_model: 'last_non_direct', first_touch_landing_page: a.first.landing_page, last_touch_landing_page: a.last.landing_page };
    for (const key of exports.UTM_KEYS) {
        result['first_touch_' + key] = a.first[key] || '';
        result['last_touch_' + key] = a.last[key] || '';
        result['utm_' + key] = a.last[key] || '';
    }
    // Also fix PostHog's default referral properties (do not use the iframe referrer).
    result.$referrer = a.last.referrer || '$direct';
    result.$referring_domain = a.last.referrer ? new URL(a.last.referrer).hostname : '$direct';
    return result;
}
function clicks(url) {
    const p = new URL(url).searchParams;
    const result = {};
    for (const key of exports.CLICK_KEYS) {
        const val = p.get(key);
        if (val && /^[A-Za-z0-9._~-]{1,200}$/.test(val))
            result[key] = val;
    }
    return result;
}
function cookie(name, value, expires, hostname, secure = true) {
    return `${name}=${value}; Path=/; Expires=${new Date(expires).toUTCString()}; SameSite=Lax${internalHost(hostname) ? '; Domain=.compagnonsdecoeur.fr' : ''}${secure ? '; Secure' : ''}`;
}
function device(userAgent) { return /iPad|Tablet/i.test(userAgent) ? 'tablet' : /Mobi|Android|iPhone/i.test(userAgent) ? 'mobile' : 'desktop'; }

return exports; })();
if (window.CDCTracking) return;
let allowed = false, ads = false, state = null;
const read = name => { try { return document.cookie.split('; ').find(s => s.startsWith(name + '='))?.slice(name.length + 1); } catch (_) { return ''; } };
const write = value => { try { document.cookie = value; } catch (_) {} };
const productNode = document.getElementById('cdc-tracking-product');
let product = {};
try { product = JSON.parse(productNode?.textContent || '{}'); } catch (_) {}
const sync = () => {
  const privacy = window.Shopify?.customerPrivacy;
  const choice = privacy?.currentVisitorConsent?.();
  allowed = choice?.analytics === 'yes' && privacy?.analyticsProcessingAllowed?.() === true;
  ads = choice?.marketing === 'yes' && privacy?.marketingAllowed?.() === true;
  if (allowed) {
    const now = Date.now();
    state = C.updateAttribution(C.decodeAttribution(read(C.ATTR_COOKIE), now), location.href, document.referrer, now, C.anonymousId(crypto));
    write(C.cookie(C.ATTR_COOKIE, encodeURIComponent(JSON.stringify(state)), state.expires, location.hostname));
    const ids = C.clicks(location.href);
    if (ads && Object.keys(ids).length) write(C.cookie(C.ADS_COOKIE, encodeURIComponent(JSON.stringify(ids)), now + C.TTL, location.hostname));
  } else { state = null; write(C.cookie(C.ATTR_COOKIE, '', 0, location.hostname)); }
  if (!allowed || !ads) write(C.cookie(C.ADS_COOKIE, '', 0, location.hostname));
  send();
  cartConsent();
};
// Server purchase fallback: the Analytics consent and the anonymous id travel with the cart (attributes copied into
// the order). Written only after an Analytics consent, cleared on refusal/revocation; never on refusal from the start.
const CART_KEY = 'cdc_cart_consent_v1';
const cartConsent = () => {
  const desired = allowed && state ? { _cdc_aid: state.id, _cdc_analytics: '1', _cdc_test: state.internal ? '1' : '' } : { _cdc_aid: '', _cdc_analytics: '', _cdc_test: '' };
  const serialized = JSON.stringify(desired);
  let previous = null;
  try { previous = sessionStorage.getItem(CART_KEY); } catch (_) {}
  if (previous === serialized || (!allowed && previous === null)) return;
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  fetch(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: desired }) })
    .then(response => { if (response.ok) { try { sessionStorage.setItem(CART_KEY, serialized); } catch (_) {} } })
    .catch(() => {});
};
// The Atelier frames: textile and every page of the single atelier page (#atelier-portrait-animal), planche pages (#atelier-planche,
// tunnel v1 04/10/2026: without it the planche Atelier never received the consent and sent nothing to PostHog).
const ATELIER_FRAMES = '#atelier-portrait-animal iframe, #atelier-planche iframe';
const send = () => {
  document.querySelectorAll(ATELIER_FRAMES).forEach(frame => {
    try { frame.contentWindow?.postMessage({ type: 'cdc-tracking-context', version: 2, analytics: allowed, marketing: ads,
      attribution: allowed && state ? encodeURIComponent(JSON.stringify(state)) : null, product: allowed ? product : {} }, 'https://portrait-animaux.compagnonsdecoeur.fr'); } catch (_) { /* about:blank: iframe ready retries */ }
  });
};
window.CDCTracking = { sync };
document.addEventListener('visitorConsentCollected', sync);
window.addEventListener('pageshow', sync);
window.addEventListener('focus', sync);
window.addEventListener('message', event => {
  const fromAtelier = [...document.querySelectorAll(ATELIER_FRAMES)].some(frame => event.source === frame.contentWindow);
  if (event.origin === 'https://portrait-animaux.compagnonsdecoeur.fr' && fromAtelier && event.data?.type === 'cdc-tracking-ready') sync();
});
if (window.Shopify?.customerPrivacy) sync();
else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) sync(); });

})();
